var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.StoreID==0)?_c('div',{staticClass:"left"},[_c('ul',{staticClass:"leftmenu"},_vm._l((_vm.list),function(item){return _c('li',{class:_vm.selectArea==item.AreaID?'active':'',on:{"click":function($event){return _vm.OnliClick(item.AreaID,item.AreaName)}}},[_vm._v(_vm._s(item.AreaName))])}),0)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a051a13e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/left.vue
// module id = null
// module chunks = 